import { Component, OnInit, ViewChild } from '@angular/core';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/classes/User.class';

@Component({
  selector: 'user-list-screen',
  templateUrl: './user-list.screen.html',
  styleUrls: ['./user-list.screen.scss'],
})
export class UserListScreenComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<User>;
  displayedColumns: string[];
  users;
  searchTerm = '';
  currentAdmin: User;

  constructor(private userApiService: UserApiService, private router: Router) {}

  async ngOnInit() {
    this.currentAdmin = await this.userApiService.getAdmin();
    this.users = await this.userApiService.getAllApprovedUser();
    this.users.data = this.sorting(this.users.data);
    this.displayedColumns = ['firstName', 'lastName', 'email', 'myAccount', 'active', 'details'];
    this.dataSource = new MatTableDataSource<User>(this.users.data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data, filter) => {
      return (
        data.firstName.toLowerCase().trim().indexOf(filter) !== -1 ||
        data.lastName.toLowerCase().trim().indexOf(filter) !== -1 ||
        data.email.trim().toLowerCase().indexOf(filter) !== -1
      );
    };
  }

  checkSyncStatus(user) {
    if (user.role !== 'mowa_admin' && (!user.magentoCustomerId || !user.requestForCompanyName)) {
      return true;
    }
  }

  private sorting(users: User[]): User[] {
    let arrLength = users.length;
    for (let i = 0; i < arrLength; i++) {
      if (users[i].active === 0) {
        users.push(users[i]);
        users.splice(i, 1);
        i -= 1;
        arrLength -= 1;
      }
    }
    return users;
  }

  viewUser(userId: number) {
    this.router.navigateByUrl(`users/${userId}`);
  }

  filterResults() {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  newUser() {
    this.router.navigateByUrl('users-choose-company');
  }
}
